module.exports = __webpack_public_path__ + "img/trustpilot-image.798eefaf.webp";